<div>
  <!-- Notification dropdown -->
  <div v-if="show" class="notification-dropdown">
    <div class="notifications-card">
     <div class="notification-card-header d-flex align-items-center justify-content-between">
      <p class="mt-2 text-white">Notifications</p>
      <button type="button" class="btn-close btn-close-white" aria-label="Close" @click="close"></button>
    </div>

      <div class="notifications-panel">
        <div class="d-flex justify-content-between align-items-center px-3 py-2 border-bottom mb-3">
          <span class="text-dark">Recent</span>
          
          <button 
            @click="mark_notification_as_read" 
            class="btn btn-sm border-0 p-0 d-flex align-items-center text-xs"
            :disabled="notifications.length === 0 || loading"
          >
            <template v-if="loading">
              <i class="fa-solid fa-spinner fa-spin me-1"></i>
              Processing...
            </template>
            <template v-else>
              <i class="fa-solid fa-check-double me-1"></i>
              Mark as read
            </template>
          </button>
        </div>
        
        <!-- Scrollable Notifications -->
        <div class="notifications-list">
          <!-- No notifications message -->
          <div v-if="notifications.length === 0" class="text-center py-3">
            <p class="text-muted text-xs">No new notifications</p>
          </div>
          
          <!-- Notification items -->
          <div
            v-for="(notification, index) in notifications"
            :key="notification.id || index"
            class="notification-item"
            :class="{ 
              'new': !notification.is_read,
              'cursor-pointer': true 
            }"
            @click="view_notification(notification)"
          >
            <p class="fw-bold mb-1 text-xs">{{ notification.verb }}</p>
            
            <!-- Display notification data -->
            <div v-if="notification.data">
              <p v-if="notification.data.lead_id" class="text-xxs p-0">
                Lead ID: {{ notification.lead_name }}
              </p>
            </div>
            
            <div class="d-flex justify-content-between align-items-center mt-2">
              <span class="timestamp">{{ notification.time }}</span>
              <button 
                class="btn btn-primary-dark text-xxs" 
                @click.stop="view_notification(notification)"
              >
                View {{ get_content_type_label(notification.content_type) }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Overlay -->
  <div v-if="show" class="notification-overlay" @click="close"></div>
</div>